import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useState, useRef, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import DealerAd from '../..';
import { useWixDealerListener } from '../../DealerAdIframe';
import ddt from '@wix/da-ddt';
import cn from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton/IconButton';
import Close16 from '@wix/da-ds/pkg/Icons/16x16/Close/Close';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import axios from 'axios';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import isEmpty from 'lodash/isEmpty';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import s from './Modal.scss';
const ModalAdUnit = ({ realEstateId })=>{
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);
    const [passedOffer, setPassedOffer] = useState(undefined);
    const isMobile = useContext(MobileContext);
    const isMounted = useIsMounted();
    const { biClientIdSigned, biClientId, useridUuid } = useContext(SessionContext);
    const isVideo = useRef(false);
    const closeHandler = useCallback(async ()=>{
        await yieldToMainAsync();
        dialogRef && dialogRef.current && dialogRef.current.close();
        await yieldToMainAsync();
        const userId = useridUuid === '' ? biClientId : useridUuid;
        const params = {
            realEstateId,
            offerId: passedOffer.offerGuid,
            userId: userId,
            targetAccountId: userId,
            loggedInAccountId: userId
        };
        if (passedOffer) {
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'CLOSE'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'SHOW_LATER'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
        }
    }, [
        biClientId,
        biClientIdSigned,
        passedOffer,
        realEstateId,
        useridUuid
    ]);
    useEffect(()=>{
        const dialog = dialogRef.current;
        let showModal = true;
        // Show the dialog
        if (dialog && isVisible && passedOffer) {
            let width = passedOffer.asset.creative.modal.desktop.width;
            let height = passedOffer.asset.creative.modal.desktop.height;
            // Mobile either is given dimensions or we scale down to 300x400
            if (isMobile) {
                var _passedOffer_asset_creative_modal_mobile_width;
                width = (_passedOffer_asset_creative_modal_mobile_width = passedOffer.asset.creative.modal.mobile.width) !== null && _passedOffer_asset_creative_modal_mobile_width !== void 0 ? _passedOffer_asset_creative_modal_mobile_width : '300';
                var _passedOffer_asset_creative_modal_mobile_height;
                height = (_passedOffer_asset_creative_modal_mobile_height = passedOffer.asset.creative.modal.mobile.height) !== null && _passedOffer_asset_creative_modal_mobile_height !== void 0 ? _passedOffer_asset_creative_modal_mobile_height : '400';
            }
            const calcWidth = `${width}px`;
            const calcHeight = `${height}px`;
            dialog.style.minWidth = calcWidth;
            dialog.style.width = calcWidth;
            dialog.style.minHeight = calcHeight;
            dialog.style.height = calcHeight;
            // Video is width only
            if (isVideo.current) {
                dialog.style.minHeight = 'auto';
                dialog.style.height = 'auto';
            }
            // Nothing to display
            if (isEmpty(passedOffer.asset.creative.modal.desktop) || isMobile && isEmpty(passedOffer.asset.creative.modal.mobile.iframeContent)) {
                showModal = false;
            }
            showModal && dialog.showModal();
        }
        // Handle outside clicks
        const clickOutside = (event)=>{
            if (dialog) {
                const rect = dialog.getBoundingClientRect();
                if (event.clientY < rect.top || event.clientY > rect.bottom) {
                    return closeHandler();
                }
                if (event.clientX < rect.left || event.clientX > rect.right) {
                    return closeHandler();
                }
            }
        };
        if (dialog) {
            dialog.addEventListener('click', clickOutside);
        }
        return ()=>{
            if (dialog) {
                dialog.removeEventListener('click', clickOutside);
            }
        };
    }, [
        isVisible,
        passedOffer,
        isMobile,
        closeHandler
    ]);
    const handler = useCallback((data)=>{
        ddt.log('dealer', 'Got command from iframe2', data);
        switch(data.command){
            case 'show-modal':
                if (data.data && data.data.asset.creative.videobanner) {
                    // If there are any non-empty keys inside videobanner,
                    // we can treat this as having video data
                    const { videobanner } = data.data.asset.creative;
                    if (Object.keys(videobanner).length > 0 && Object.entries(videobanner).map(([k, v])=>Object.keys(v || {}).length).reduce((acc, i)=>acc + i, 0) > 0) {
                        isVideo.current = true;
                    }
                }
                setPassedOffer(data.data);
                setIsVisible(true);
                break;
            default:
                break;
        }
    }, []);
    useWixDealerListener(realEstateId, handler);
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ModalAdUnit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isVisible && s['visible'])
    }, /*#__PURE__*/ React.createElement("dialog", {
        className: cn(s['dialog'], isVideo.current && s['video']),
        ref: dialogRef
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        disableLazy: true,
        className: s['unit'],
        realEstateId: realEstateId,
        extraParams: process.env.NODE_ENV === 'development' ? {
            forcefixture: 'modalvid'
        } : {}
    }), !isVideo.current && /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: Close16,
        size: 'medium',
        "aria-label": t('common.close'),
        className: cn(s['close']),
        onClick: closeHandler
    })), isVideo.current && /*#__PURE__*/ React.createElement(IconButton, {
        icon: Close16,
        size: 'medium',
        "aria-label": t('common.close'),
        className: cn(s['close'], s['video']),
        onClick: closeHandler
    }))));
};
ModalAdUnit.displayName = 'ModalAdUnit';
export default ModalAdUnit;

//# sourceMappingURL=Modal.js.map